import { render, staticRenderFns } from "./FinancialLimitsPerCountry.vue?vue&type=template&id=17eb7525&scoped=true&"
import script from "./FinancialLimitsPerCountry.vue?vue&type=script&lang=js&"
export * from "./FinancialLimitsPerCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb7525",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
